import qs from 'qs';

import { normalizeSrc } from '@/app/components/media/app-image/shared/image-source';

interface UrlParts {
  base: string;
  hash: string;
  query: string;
}

export const splitUrlParts = (urlInput: unknown): UrlParts => {
  const url = normalizeSrc(urlInput);
  const hashIndex = url.indexOf('#');
  const beforeHash = hashIndex === -1 ? url : url.slice(0, hashIndex);
  const hash = hashIndex === -1 ? '' : url.slice(hashIndex);
  const queryIndex = beforeHash.indexOf('?');

  if (queryIndex === -1) {
    return {
      base: beforeHash,
      hash,
      query: '',
    };
  }

  return {
    base: beforeHash.slice(0, queryIndex),
    hash,
    query: beforeHash.slice(queryIndex + 1),
  };
};

// Do not enable qs `comma: true` — ImageKit `tr` values can contain commas
// (e.g. `bg-255,0,0`) and must stay intact as a single string.
export const parseQuery = (query: unknown): Record<string, unknown> =>
  qs.parse(typeof query === 'string' ? query : '', {
    ignoreQueryPrefix: true,
  });

export const getQueryParams = (urlInput: unknown): Record<string, unknown> =>
  parseQuery(splitUrlParts(urlInput).query);

export const mergeQuery = (
  urlInput: unknown,
  patch: Record<string, unknown>
): string => {
  const url = normalizeSrc(urlInput);
  if (!url) return '';

  const { base, hash, query: rawQuery } = splitUrlParts(url);
  const q = parseQuery(rawQuery);
  const next: Record<string, unknown> = { ...q, ...patch };
  for (const key of Object.keys(next)) {
    if (next[key] === undefined) {
      delete next[key];
    }
  }
  const query = qs.stringify(next, {
    addQueryPrefix: false,
    encode: true,
    indices: false,
    arrayFormat: 'comma',
    skipNulls: true,
  });
  return `${query ? `${base}?${query}` : base}${hash}`;
};
